import React, { Component } from 'react';
import { connect } from 'react-redux';
import DandOSelector from "./DandOSelector";
import { fetch_dandos, select_dando } from "../redux/actions";
import Paginator from "../../hoc/Paginator/Paginator";

class DandOSelectorContainer extends Component {

	state = {
		searchText: '',
		sortText: '',
		sortOrderType: '',
	}

	componentDidMount() {
		this.fetchDandos();
		localStorage.removeItem('searchValue');
		localStorage.removeItem('sortParams');
	}

	onDandOSelect = (dando) => {
		if (dando.dandOId !== null) {
			this.props.history.push("/cases/" + (parseInt(dando.dandOId, 10)));
			sessionStorage.setItem('Type','COMMISSION');
			sessionStorage.setItem('DANDO',true);

		} else {
			this.props.history.push("/cases/0");
		}
	};

	handleSearch = (searchText) => {
		this.setState({ searchText }, () => {
			this.fetchDandos();
		});
	}

	handleSort = (sortText, sortOrderType) => {
		this.setState({ sortText, sortOrderType }, () => {
			this.fetchDandos();
		});
	}

	handleClear = () =>{
		this.setState({searchText: '', sortText: '', sortOrderType: ''}, () => {
			this.fetchDandos();
		})
	}

	fetchDandos = (pageNumber) => {
		const { searchText, sortText, sortOrderType } = this.state;
		this.props.fetch_dandos({
			page: pageNumber ? pageNumber : 0,
			search: searchText,
			sortKey: sortText,
			sortOrder: sortOrderType
		});
	}

	render() {
		const { sortText, sortOrderType } = this.state;
		let mainDisplay = <div className={"CorrectiveInfoText"}>Please upgrade to the SCADA Premium platform.</div>;
		if (true /*this.props.dandoEnabled*/) {
			mainDisplay = <React.Fragment>
				<DandOSelector
					dandos={this.props.dandos.dandos_in_current_page}
					onDandOClick={this.onDandOSelect}
					firmSettings={this.props.firmSettings}
					handleSearch={this.handleSearch}
					handleClear={this.handleClear}
					handleSort={this.handleSort}
					sortValue={sortText}
					sortOrder={sortOrderType}
				/>
				<Paginator
					name={"dando-selector"}
					totalPages={this.props.totalPages}
					currentPage={this.props.currentPage}
					setPage={(pageNumber) => this.fetchDandos(pageNumber, sortText, sortOrderType)} />
			</React.Fragment>
		}

		return (
			<React.Fragment>
				{mainDisplay}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		dandos: state.dandos,
		currentPage: state.dandos.current_page,
		totalPages: state.dandos.total_pages,
		firmSettings: state.firmSettings,
		dandoEnabled: true //state.firmSettings.dandoEnabled
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetch_dandos: (input) => dispatch(fetch_dandos(input)),
		select_dando: (dando_id) => dispatch(select_dando(dando_id))
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(DandOSelectorContainer);


// WEBPACK FOOTER //
// ./src/dandos/components/DandOSelectorContainer.js